import styled from 'styled-components'
import { theme } from './../../common'
import { Row } from 'react-bootstrap'

export const StyledTitle = styled.h1`
    color: ${theme.primary};
    text-transform: uppercase;
    font-size: 2.5em;
    font-weight: bold;
    word-break: break-word;
    @media screen and (max-width: 576px) {
        font-size: 1.8em;
    }
`
export const StyledSubtitle = styled.h2`
    font-weight: bold;
`
export const StyledDate = styled.h3`
    font-size: 1.1em;
    margin-bottom: 5%;
`
export const StyledContent = styled.div`
    font-size: 1.2em;
`
export const StyledImage = styled.img`
    width: 100%;
    height: auto;
`
export const StyledRow = styled(Row)`
    background-color: ${theme.lightGrey};
    padding: 0px;
`